// extracted by mini-css-extract-plugin
export default {"can_not_edit_text":"styles_can_not_edit_text__QX-GT","save_button":"styles_save_button__h7Jso","cardpadless":"styles_cardpadless__7TKF1","date_picker":"styles_date_picker__JfZS7"};